module.exports = __webpack_public_path__ + "img/ATI.png";